/*
 * @Copyright: Copyright (c) Pray. All rights reserved.
 * @Author: Raguvind Tharanitharan
 * @Date: 2022-08-17 10:18:12
 * @Last Modified by: Raguvind Tharanitharan
 * @Last Modified time: 2022-09-18 10:21:01
*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import AppRouter from './app-router';
import RootStore from './root-store';
// import GlobalStyles from './global-styles';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeProvider } from '@emotion/react';
import PrayTheme from './default-theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
const clientId = `${process.env.REACT_APP_GOOLGE_CLIENT_ID}`;

root.render(
  <>
    {/* Setting up the root store */}
    <Provider store={RootStore}>
      <GoogleOAuthProvider clientId={clientId}>
        <ThemeProvider theme={PrayTheme}>
          <AppRouter />
        </ThemeProvider>
      </GoogleOAuthProvider>
    </Provider>
  </>
);